// src/Layout.js (Version corrigée avec Drapeaux au Milieu de la ligne du haut)
import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { FaInstagram, FaFacebook, FaTiktok } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import './App.css'; 

function Layout() {
    const { t } = useTranslation();

    const navLinks = [
        { key: 'features', text: t('nav_features') || 'Features', href: '#features' },
        { key: 'testimonials', text: t('nav_testimonials') || 'Testimonials', href: '#testimonials' },
        { key: 'about_us', text: t('nav_about_us') || 'About Us', href: '#about-us' },
        { key: 'faq', text: t('nav_faq') || 'FAQ', href: '#faq' },
    ];

    return (
        <div className="layout-wrapper">
            <header className="site-header">
                
                {/* LIGNE 1 : LOGO (G) | DRAPEAUX (M) | BOUTONS (D) */}
                <div className="header-top-row">
                    
                    {/* 1. Logo et titre (Gauche) */}
                    <div className="header-logo-title">
                        <h1>Bèlfich PAM</h1>
                        <Link to="/">
                            <img src="/logo.jpg" alt="Bèlfich PAM" className="header-logo" />
                        </Link>
                    </div>
                    
                    {/* 2. Drapeaux de Langue (Milieu) */}
                    <div className="header-language-center"> 
                        <LanguageSwitcher />
                    </div>
                    
                    {/* 3. Groupe de Boutons (Droite) */}
                    <div className="header-right-group-buttons">
                        <div className="btn-group">
                            <button className="btn btn-primary">{t('btn_view_picks') || 'VIEW PICKS'}</button>
                            
                            <Link to="/login" className="btn btn-secondary">
                                {t('btn_login') || 'LOG IN'}
                            </Link>
                        </div>
                    </div>
                </div>

                {/* LIGNE 2 : NAVIGATION (Centrée) */}
                <div className="header-bottom-row">
                    <nav className="main-nav">
                        <ul className="nav-list">
                            {navLinks.map((link) => (
                                <li key={link.key}>
                                    <a href={link.href} className="nav-link">{link.text}</a>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            </header>

            {/* CONTENU SPÉCIFIQUE À LA PAGE (Outlet) */}
            <main>
                <Outlet /> 
            </main>

            {/* FOOTER COMMUN (inchangé) */}
            <footer>
                <p>
                    © <span id="year"></span> {t('footer_rights')}
                </p>

                <p className="footer-developer">
                    {t('footer_dev')}{" "}
                    <a
                        href="https://djovanylevasseur.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="developer-link"
                    >
                        Djovany Levasseur
                    </a>
                </p>

                <div className="social-icons">
                    <a href="https://instagram.com/tonpseudo" target="_blank" rel="noopener noreferrer">
                        <FaInstagram />
                    </a>
                    <a href="https://facebook.com/tonpage" target="_blank" rel="noopener noreferrer">
                        <FaFacebook />
                    </a>
                    <a href="https://tiktok.com/@toncompte" target="_blank" rel="noopener noreferrer">
                        <FaTiktok />
                    </a>
                </div>
            </footer>
        </div>
    );
}

export default Layout;